// export { default as Signup } from './Signup'
// export { default as Login } from './Login'
// export { default as ForgotPassword } from './ForgotPassword'
// export { default as ResetPassword } from './ResetPassword'
// export { default as LoginMFACode } from './LoginMFACode'
// export { SessionExpired } from './SessionExpired'

import React from 'react'
import { withLazyRoute } from '@/components/Lazy/LazyRouteWrapper'

export const Login = withLazyRoute(
  React.lazy(() => import('./Login')),
  'Loading login...',
)

// export const AccountDeactivated = withLazyRoute(
//   React.lazy(() => import("./AccountDeactivated")),
//   "Loading..."
// );

export const ForgotPassword = withLazyRoute(
  React.lazy(() => import('./ForgotPassword')),
  'Loading forgot password...',
)

export const LoginMFACode = withLazyRoute(
  React.lazy(() => import('./LoginMFACode')),
  'Loading MFA verification...',
)

// export const NeedVerification = withLazyRoute(
//   React.lazy(() => import('./NeedVerification')),
//   'Loading need verification...',
// )

export const NotFound = withLazyRoute(
  React.lazy(() => import('./NotFound')),
  'Loading...',
)

export const ResetPassword = withLazyRoute(
  React.lazy(() => import('./ResetPassword')),
  'Loading reset password...',
)

export const SessionExpired = withLazyRoute(
  React.lazy(() => import('./SessionExpired')),
  'Loading...',
)

// export const SignOut = withLazyRoute(
//   React.lazy(() => import('./SignOut')),
//   'Loading sign out...',
// )

// export const SignUp = withLazyRoute(
//   React.lazy(() => import('./SignUp')),
//   'Loading sign up...',
// )
